<template>
  <validation-observer v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('secondStepAvailable', $event)" />

    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            id="titulo-saneamento-voc"
            v-model="_campos.titulo"
            label="Título"
            outlined
            :error-messages="errors"
            class="my-0"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="12">
        <v-alert dense outlined type="info" color="blue" class="pa-2">Utilize pelo menos um filtro</v-alert>

        <validation-provider rules="required" immediate>
          <input v-model="minOneFilterSelected" type="hidden" name="valida-filtragem-minima" />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-select
            v-model="_campos.tipoBase"
            label="Tipo da base"
            item-value="key"
            item-text="value"
            :items="[
              { key: 'AMBAS', value: 'Ambos' },
              { key: 'AIC', value: 'Obra em Curso' },
              { key: 'AIS', value: 'Obra Unitizada' }
            ]"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="9">
        <v-textarea
          id="obras-saneamento-voc"
          v-model="_campos.obras"
          class="mt-0 pt-0"
          label="Obras"
          placeholder="Insira os códigos das obras, um por linha. Ex.:

CI1944457111 
CI1944457348"
          rows="5"
          no-resize
          clearable
          clear-icon="mdi-close-circle"
        />
      </v-col>
      <v-col id="obras-nao-pertence-saneamento-voc" class="mt-12 pl-0" cols="3">
        <v-checkbox v-model="_campos.obrasNaoPertencem" class="my-0 py-0" hide-details label="Não pertence" />
      </v-col>
    </v-row>

    <v-row class="mx-auto">
      <v-col cols="9">
        <v-textarea
          id="tipologias-saneamento-voc"
          v-model="_campos.tipologias"
          class="mt-0 pt-0"
          label="Tipologias"
          placeholder="Insira os códigos das tipologias, um código por linha. Ex.: 

RAU
RAR"
          rows="5"
          no-resize
          clearable
          clear-icon="mdi-close-circle"
        />
      </v-col>
      <v-col id="tipologias-nao-pertence-saneamento-voc" class="mt-12 pl-0" cols="3">
        <v-checkbox v-model="_campos.tipologiasNaoPertencem" class="my-0 py-0" hide-details label="Não pertence" />
      </v-col>
    </v-row>

    <v-row id="data-imobilizacao-saneamento-voc" class="mx-auto">
      <v-col class="pb-0 pt-1" cols="5">
        <v-menu
          v-model="_campos.menuPickerImob[0]"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                required_if: _campos.dataImob.fimFormatted != null && _campos.dataImob.fimFormatted.length > 0,
                min: 10
              }"
            >
              <v-text-field
                v-model="_campos.dataImob.inicioFormatted"
                v-mask="'##/##/####'"
                :error-messages="errors"
                class="pt-0"
                label="Data Imobilização"
                prepend-icon="mdi-calendar"
                clearable
                v-bind="attrs"
                v-on="on"
                @blur="_campos.dataImob.inicio = parseDate(_campos.dataImob.inicioFormatted)"
              />
            </validation-provider>
          </template>
          <v-date-picker
            v-model="_campos.dataImob.inicio"
            locale="pt-br"
            @input="
              _campos.menuPickerImob[0] = false;
              _campos.dataImob.inicioFormatted = formatDate(_campos.dataImob.inicio);
            "
          />
        </v-menu>
      </v-col>
      <v-col class="pb-0 pt-5 text-center" style="min-width: 60px !important" cols="1">
        <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">até</span>
      </v-col>
      <v-col class="pb-0 pt-1" cols="5">
        <v-menu
          v-model="_campos.menuPickerImob[1]"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <validation-provider
              v-slot="{ errors }"
              :rules="{
                required_if: _campos.dataImob.inicioFormatted != null && _campos.dataImob.inicioFormatted.length > 0,
                min: 10
              }"
            >
              <v-text-field
                v-model="_campos.dataImob.fimFormatted"
                v-mask="'##/##/####'"
                :error-messages="errors"
                class="pt-0"
                label="Data Imobilização"
                prepend-icon="mdi-calendar"
                clearable
                v-bind="attrs"
                v-on="on"
                @blur="_campos.dataImob.fim = parseDate(_campos.dataImob.fimFormatted)"
              />
            </validation-provider>
          </template>
          <v-date-picker
            v-model="_campos.dataImob.fim"
            locale="pt-br"
            @input="
              _campos.menuPickerImob[1] = false;
              _campos.dataImob.fimFormatted = formatDate(_campos.dataImob.fim);
            "
          />
        </v-menu>
      </v-col>
    </v-row>
  </validation-observer>
</template>

<script>
  import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';

  export default {
    name: 'SaneamentoVocFirstWizardTab',

    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue')
    },

    mixins: [DateFormatterMixins],

    props: {
      campos: {
        type: Object,
        required: true
      }
    },

    emits: ['secondStepAvailable', 'update:campos'],

    data() {
      return {
        //
      };
    },

    computed: {
      _campos: {
        get() {
          return this.campos;
        },
        set(newValues) {
          this.$emit('update:campos', newValues);
        }
      },

      minOneFilterSelected() {
        return this._campos.obras || this._campos.tipologias || (this._campos.dataImob.inicio && this._campos.dataImob.fim)
          ? true
          : undefined;
      }
    }
  };
</script>
